import { textStyle } from '@/components/ui/Typography/Body/Text/style';
import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineClientScheduling のスタイル
 */
export const hotlineClientSchedulingStyle = tv({
    slots: {
        acceptButton: ['mx-auto mt-24'],
        base: [
            'flex flex-col items-center',
            'bg-blue-gray-75',
            'p-16',
            'rounded-md',
        ],
        bottomContentWrap: [
            'flex flex-col items-center',
            'w-full',
            'border-t border-x-0 border-b-0 border-solid border-gray-300',
            'py-24 px-16',
            'mt-24',
        ],
        buttonWrap: ['flex flex-col lg:flex-row-reverse gap-16', 'mt-24'],
        fixText: [textStyle({ color: 'base', size: 'sm' }), 'flex flex-wrap'],
        interviewInfoText: [
            'flex flex-col items-center gap-8',
            'text-center',
            'w-full',
            'p-16',
            'mt-16',
            'bg-white',
            'rounded-md',
        ],
    },
});
